// Icons
import { FiArrowRight, FiSun } from "@/lib/icons"

// Translations
import { useTrans } from "@/i18n"
import { useLang } from "@/context/useLang"

// Router
import { useLocation } from "@/lib/router"

// API
import { useApiV1InvestmentSessionRetrieve } from "@/api/rest/generated/api/api"

// UI
import { ButtonLink, Button } from "@/components/Button"
import { Heading } from "@/components/Typography"

// Context
import { useRequiredStepsBeforePendingInvestment } from "@/context/requiredStepsBeforePendingInvestment"

/**
 * PendingInvestment
 * @returns
 */
export function PendingInvestment() {
	// Translations
	const t = useTrans("common")
	const { formatCurrency } = useLang()

	// Queries
	const { data } = useApiV1InvestmentSessionRetrieve()

	// Context
	const {
		amountOfRequiredActionsLeft,
		onRedirectToNextStep,

		nextStepUrl,
	} = useRequiredStepsBeforePendingInvestment()

	// Router
	const location = useLocation()

	// Variables
	const showNextButton =
		amountOfRequiredActionsLeft !== undefined &&
		amountOfRequiredActionsLeft !== 0 &&
		nextStepUrl !== undefined &&
		location.pathname !== nextStepUrl
	const showInvestButton = amountOfRequiredActionsLeft === 0

	// If no data, return null
	if (!data?.pending_investment) return null

	// Data is available, render the component
	return (
		<div
			className="relative overflow-x-scroll rounded-xs pt-6 sm:rounded-lg md:pt-0"
			data-testid="open_investments"
		>
			<div className="py-4 text-center">
				<div className="relative z-1 rounded-lg shadow">
					<div className="border-primary-500 pointer-events-none absolute inset-0 rounded-lg border-2" />
					<div className="absolute inset-x-0 top-0 flex w-full translate-y-px justify-center">
						<div className="bg-primary-500 -translate-y-1/2 rounded-xl px-5 py-1 text-black">
							<Heading as="h6" className="flex items-center">
								<FiSun
									className="animate-spin-slowish mr-2 text-black"
									size={16}
								/>
								{
									data?.pending_investment
										?.crowdfunding_campaign?.title
								}
							</Heading>
						</div>
					</div>
					<div className="flex flex-col items-center rounded-lg bg-white px-8 pt-10 pb-6">
						<p>
							{t("common:open_investments.copy", {
								amount: formatCurrency(
									Number(data?.pending_investment?.amount),
								),
								project_name:
									data?.pending_investment
										?.crowdfunding_campaign?.title,
							})}
						</p>

						{/** Not yet finished all steps */}
						{amountOfRequiredActionsLeft > 0 && (
							<p className="font-bold">
								{t("common:open_investments.required_steps")}
							</p>
						)}

						{/** Show next step */}
						{showNextButton ? (
							<Button
								onClick={() => onRedirectToNextStep()}
								className="mt-4"
							>
								{t("investor:profile.generic.button")}
							</Button>
						) : null}

						{/** Show invest button */}
						{showInvestButton ? (
							<ButtonLink
								to={data?.pending_investment?.url}
								className="group mt-4 flex justify-center pl-6"
								variant="primary"
								data-testid="common:open_investments.button"
							>
								{t("common:open_investments.button")}
								<FiArrowRight className="ml-2 transition group-hover:translate-x-1" />
							</ButtonLink>
						) : null}
					</div>
				</div>
			</div>
		</div>
	)
}
